import { Component, Inject, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  MAT_SNACK_BAR_DATA,
  MatSnackBarRef
} from '@angular/material/snack-bar';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'webpay-snackbar-dialog',
  standalone: true,
  imports: [CommonModule, TranslateModule],
  templateUrl: './snackbar-dialog.component.html',
  styleUrls: ['./snackbar-dialog.component.scss']
})
export class SnackbarDialogComponent implements OnInit {
  title: string | undefined;
  message: string | undefined;
  type: 'error' | 'success' | 'warn' | undefined;
  action: string | undefined = '';

  constructor(
    public snackBarRef: MatSnackBarRef<SnackbarDialogComponent>,
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    @Inject(MAT_SNACK_BAR_DATA) public data: any
  ) {}

  ngOnInit(): void {
    this.title = this.data['title'];
    this.message = this.data['message'];
    this.type = this.data['type'];
    this.action = this.data['action'];
  }

  get fullClassName():
    | 'snackbar-dialog snackbar-dialog--error'
    | 'snackbar-dialog snackbar-dialog--warn'
    | 'snackbar-dialog snackbar-dialog--success' {
    switch (this.type) {
      case 'error':
        return 'snackbar-dialog snackbar-dialog--error';

      case 'warn':
        return 'snackbar-dialog snackbar-dialog--warn';

      case 'success':
        return 'snackbar-dialog snackbar-dialog--success';

      default:
        return 'snackbar-dialog snackbar-dialog--error';
    }
  }
}
